var ThumbnailPreviews;
(function (ThumbnailPreviews) {
    myonce('thumbnail', () => {
        const $thumbnailPreviews = document.querySelectorAll(".thumbnail-preview");
        if ($thumbnailPreviews.length) {
            $thumbnailPreviews.forEach(($thumbnailPreview) => {
                let currentIndex = 0;
                const prevControlArrow = $thumbnailPreview.querySelector(".arrow-prev");
                const nextControlArrow = $thumbnailPreview.querySelector(".arrow-next");
                const thumbnailItems = $thumbnailPreview.querySelectorAll(".thumbnail-image");
                const targetImage = $thumbnailPreview.querySelector(".target-image").querySelector("img");
                let isMobile;
                let boxSize;
                let containerSize;
                function getSizes() {
                    var _a, _b, _c, _d;
                    isMobile = window.innerWidth < 992; 
                    boxSize = isMobile
                        ? ((_a = $thumbnailPreview.querySelector(".thumbnail-box")) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0
                        : ((_b = $thumbnailPreview.querySelector(".thumbnail-box")) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
                    containerSize = isMobile
                        ? ((_c = $thumbnailPreview.querySelector(".thumbnail-container")) === null || _c === void 0 ? void 0 : _c.clientWidth) ||
                            0
                        : ((_d = $thumbnailPreview.querySelector(".thumbnail-container")) === null || _d === void 0 ? void 0 : _d.clientHeight) ||
                            0;
                }
                function setSlide(newIndex) {
                    currentIndex = newIndex;
                    if (containerSize > 0) {
                        $thumbnailPreview.getElementsByClassName("thumbnail-container")[0].style.transform = isMobile
                            ? "translateX(calc(-" + boxSize + "px * " + newIndex + "))"
                            : "translateY(calc(-" + boxSize + "px * " + newIndex + "))";
                        setArrowControls();
                    }
                }
                function setArrowControls() {
                    const elementLength = Math.ceil(containerSize / boxSize);
                    if (elementLength > 1) {
                        currentIndex > 0 ? prevControlArrow.classList.remove('d-none') : prevControlArrow.classList.add('d-none');
                        currentIndex < elementLength - 1 ? nextControlArrow.classList.remove('d-none') : nextControlArrow.classList.add('d-none');
                    }
                    else {
                        nextControlArrow.classList.add('d-none');
                        prevControlArrow.classList.add('d-none');
                    }
                }
                function prevSlide() {
                    if (currentIndex > 0) {
                        setSlide(currentIndex - 1);
                    }
                }
                function nextSlide() {
                    if (currentIndex < Math.ceil(containerSize / boxSize) - 1) {
                        setSlide(currentIndex + 1);
                    }
                }
                function removeActiveImage(thumbnailItems) {
                    thumbnailItems.forEach(thumbnailItem => {
                        if (thumbnailItem.classList.contains('active')) {
                            thumbnailItem.classList.remove('active');
                        }
                    });
                }
                function setTargetImage(thumbnail) {
                    const image = thumbnail.querySelector("img");
                    thumbnail.classList.add('active');
                    targetImage.src = image ? image.src : null;
                }
                function setTargetImageZoom(thumbnail) {
                    if (document.getElementById("zoom-image") != null) {
                        const image = thumbnail.querySelector("img");
                        document.getElementById("target-image").removeChild(document.getElementsByClassName("js-image-zoom__zoomed-area")[0]);
                        document.getElementById("target-image").removeChild(document.getElementsByClassName("js-image-zoom__zoomed-image")[0]);
                        var options = {
                            zoomPosition: "original",
                            zoomWidth: 500,
                            height: 500,
                            width: 500,
                            img: image ? image.src : null
                        };
                        new ImageZoom(document.getElementById("target-image"), options);
                        document.querySelector("#target-image").querySelector("img").style.width = "auto";
                        if (window.innerWidth <= 992) { 
                            document.querySelector("#target-image").querySelector("img").style.height = "auto";
                        }
                    }
                }
                getSizes();
                setSlide(currentIndex);
                const hammer = new Hammer($thumbnailPreview);
                hammer.on("swipeleft", () => {
                    nextSlide();
                });
                hammer.on("swiperight", () => {
                    prevSlide();
                });
                if (prevControlArrow) {
                    prevControlArrow.addEventListener("click", () => {
                        prevSlide();
                    });
                }
                if (nextControlArrow) {
                    nextControlArrow.addEventListener("click", () => {
                        nextSlide();
                    });
                }
                for (let index = 0; index < thumbnailItems.length; index++) {
                    const thumbnail = thumbnailItems[index];
                    if (index === 0) {
                        setTargetImage(thumbnail);
                    }
                    thumbnail.addEventListener("click", () => {
                        removeActiveImage(thumbnailItems);
                        setTargetImage(thumbnail);
                        setTargetImageZoom(thumbnail);
                    });
                }
                window.addEventListener("resize", () => {
                    getSizes();
                    setSlide(currentIndex);
                });
            });
        }
    });
})(ThumbnailPreviews || (ThumbnailPreviews = {}));
